const e = "Aparthoteles", s = "Apartamentos", o = "Negocios", t = "Campings", a = "Pareja", n = "Familia", i = "Amigos", r = "Albergues", l = "Hoteles", c = "Resorts", m = "Restaurantes", d = {
  "{num} reviews": "{num} valoraciones",
  "<em>TOP {position}</em> {hotelType} in {location}": "<em>TOP {position}</em> {hotelType} en {location}",
  "All languages": "Todos los idiomas",
  "All traveler types": "Todo tipo de viajeros",
  Aparthotels: e,
  Apartments: s,
  "B&Bs": "B&Bs",
  "based on {number} reviews": "basado en {number} valoraciones",
  Business: o,
  Campsites: t,
  Couple: a,
  Family: n,
  Friend: i,
  "Highlighted reviews": "Valoraciones destacadas",
  Hostels: r,
  Hotels: l,
  "No reviews found": "No se han encontrado reseñas",
  "Pet-friendly": "Admite mascotas",
  "Posted on {reviewer}": "Publicado en {reviewer}",
  "Read Reviews": "Ver reseñas",
  Resorts: c,
  Restaurants: m,
  "Review Summary": "Valoraciones",
  "Reviews by Source": "Valoraciones por fuente"
};
export {
  e as Aparthotels,
  s as Apartments,
  o as Business,
  t as Campsites,
  a as Couple,
  n as Family,
  i as Friend,
  r as Hostels,
  l as Hotels,
  c as Resorts,
  m as Restaurants,
  d as default
};
//# sourceMappingURL=es.B_It2UKm.js.map
